import React from "react";
import { TableCell, TableRow } from "@mui/material";
import ColumnFilter from "./ColumnFilter";

const HeaderFilter = ({ columns, filters, onFilterChange }) => {
  return (
    <TableRow>
      <TableCell padding="checkbox" />
      {columns.map((col) => (
        <TableCell key={col.field} align={col.align || "left"}>
          {col.filterable && (
            <ColumnFilter
              field={col.field}
              fieldType={col.type}
              headerName={col.headerName}
              value={filters[col.field]}
              onFilterChange={onFilterChange}
              hiddenFilterOptions={col.hiddenFilterOptions}
            />
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default HeaderFilter;
